<template>
  <div
    ref="dialog"
    class="mdc-dialog"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="my-dialog-title"
    aria-describedby="my-dialog-content"
    @keyup.enter="onClickOnSubmit()"
  >
    <div class="mdc-dialog__container">
      <div class="mdc-dialog__surface">
        <h2 class="mdc-dialog__title" id="my-dialog-title">Sign up</h2>
        <div class="mdc-dialog__content" id="my-dialog-content">
          <p
            v-if="errored"
            class="text-error"
          >There was an error. Check your email and password are valid or try again later</p>

          <p>If you have local changes, they will be kept in your new account</p>
          <Input v-model="email" label="Email"></Input>
          <div class="separator"></div>
          <Input v-model="password" label="Password" type="password"></Input>
          <div class="separator"></div>

          <Checkbox
            label="I have read and accept the <a href='https://docs.google.com/document/d/1Ws9BShodxPo8ZH-5uG2EqM4FljZcaK9Q9l5EJtHbFbk/edit?usp=sharing' target='_blank'>Privacy policy</a>"
            v-model="accepted"
          ></Checkbox>
        </div>
        <footer class="mdc-dialog__actions">
          <button
            type="button"
            class="mdc-button mdc-dialog__button"
            data-mdc-dialog-action="close"
          >
            <span class="mdc-button__label">Cancel</span>
          </button>
          <button
            :disabled="!canSignUp"
            @click="onClickOnSubmit()"
            type="button"
            class="mdc-button mdc-button--raised mdc-dialog__button"
          >
            <span class="mdc-button__label">Sign up</span>
          </button>
        </footer>
      </div>
    </div>
    <div class="mdc-dialog__scrim"></div>
  </div>
</template>

<script>
import { MDCDialog } from "@material/dialog";
import Input from "./Input.vue";
import Checkbox from "@/components/Checkbox.vue";

export default {
  props: ["visible"],
  mounted() {
    this.dialog = new MDCDialog(this.$refs.dialog);
    this.dialog.listen("MDCDialog:closed", () => {
      this.$emit("onClosed");
    });
    this.visible && this.dialog.open();
  },
  data() {
    return {
      errored: false,
      dialog: null,
      email: "",
      password: "",
      accepted: false
    };
  },
  methods: {
    onClickOnSubmit() {
      if (this.canSignUp) {
        this.$firebase
          .auth()
          .createUserWithEmailAndPassword(this.email, this.password)
          .catch(error => {
            console.error(error);
            this.errored = true;
          })
          .then(response => {
            if (response) {
              this.errored = false;
              this.$emit("onSignedUp", response.user);
            }
          });
      }
    }
  },
  computed: {
    canSignUp() {
      return this.accepted && this.email && this.password;
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.errored = false;
        this.dialog.open();
      } else {
        this.dialog.close();
      }
    }
  },
  components: {
    Input,
    Checkbox
  }
};
</script>

<style lang="scss" scoped>
.mdc-dialog__surface {
  min-width: 380px;
  max-width: 380px;
}
.separator {
  height: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/SignUpDialog.vue